/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 19/8/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {QwoachFileType} from "@shared/Drive/QwoachFileType";
import QwoachFile from "@shared/Drive/QwoachFile";
import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem";
import DocSignDocument from "@/core/modules/DocSign/data/DocSignDocument/DocSignDocument";
import DocSignTemplateItem from "@/core/modules/DocSign/data/DocSignTemplateItem";
import CommonObject from "@shared/CommonObject";

export default class QwoachFileRef extends BaseObject {

	id: string = null
	name: string = null
	qwoachFileType: QwoachFileType = null
	url: string = null


	constructor(fileId = null, fileName = null, qwoachFileType = null) {
		super();
		this.id = fileId;
		this.name = fileName;
		this.qwoachFileType = qwoachFileType;
	}

	isLegalDoc(){
		return this.qwoachFileType === QwoachFileType.LEGAL_DOC
	}
	isLegalDocTemplate(){
		return this.qwoachFileType === QwoachFileType.LEGAL_DOC_TEMPLATE
	}
	isForm(){
		return this.qwoachFileType === QwoachFileType.FORM
	}
	isDriveFile(){
		return this.qwoachFileType === QwoachFileType.DRIVE_FILE || this.qwoachFileType === QwoachFileType.LINK
	}

	toNameAndLink(coachId, clientId){
		return {
			name: this.name,
			link: this.getFileUrl(coachId, clientId)
		}
	}

	getFileUrl(coachId, clientId){

		let generateLink = CommonObject.generateLink//Vue.config.globalProperties.generateLink

		switch (this.qwoachFileType){
			case QwoachFileType.LEGAL_DOC:
				return generateLink("SignDocumentPath", {coachId: coachId, documentId: this.id}, {clientId: clientId})
			// TODO define link for the legal doc template
			// case QwoachFileType.LEGAL_DOC_TEMPLATE:
			// 	return generateLink("SignDocumentPath", {coachId: coachId, documentId: this.id, clientId: clientId})
			case QwoachFileType.FORM:
				return generateLink("FormQuestionsView", {coachId: coachId, formId: this.id}, {clientId: clientId})
			case QwoachFileType.DRIVE_FILE:
				return generateLink("StorageContentRoute", {}, {coid: coachId, src_d: this.id})
			case QwoachFileType.LINK:
				return this.url

		}
		return null
	}

	static fromFile(file){
		let fileRef
		if(file instanceof QwoachFile){
			fileRef = new QwoachFileRef(file.id, file.name, file.type)
			if(file.isLink()){fileRef.url = file.getAbsoluteUrl()}
		} else if(file instanceof FormItem){
			fileRef = new QwoachFileRef(file.id, file.getTitle(), QwoachFileType.FORM)
		} else if(file instanceof DocSignDocument){
			fileRef = new QwoachFileRef(file.id, file.name, QwoachFileType.LEGAL_DOC)
		} else if(file instanceof DocSignTemplateItem){
			fileRef = new QwoachFileRef(file.id, file.name, QwoachFileType.LEGAL_DOC_TEMPLATE)
		}
		return fileRef
	}

	static async shareWith(targetId, file, dataManager, updateCallback = (updateFunc, obj) => updateFunc(obj)){
		if(!Array.isArray(targetId)){
			targetId = [targetId]
		}
		let updateFunc = getUpdateFuncInternal(file, dataManager)
		let obj = {
			id: file.id,
			sharedWithIds: dataManager.fieldValueArrayUnion(...targetId),
		}

		await updateCallback(updateFunc, obj)
	}

	static async unShareWith(targetId, file, dataManager, updateCallback){
		if(!Array.isArray(targetId)){
			targetId = [targetId]
		}

		let directShareIds = targetId.map(id => QwoachFile.asDirectSharedId(id))
		let inderectShareIds = targetId.map(id => QwoachFile.asInderectSharedId(id))

		targetId = [... new Set([...directShareIds, ...inderectShareIds])]

		let updateFunc = getUpdateFuncInternal(file, dataManager)
		let obj = {
			id: file.id,
			sharedWithIds: dataManager.fieldValueArrayRemove(...targetId)
		}
		if(updateCallback){
			await updateCallback(updateFunc, obj)
		} else {
			await updateFunc(obj)
		}
	}


}

function getUpdateFuncInternal(file, dataManager){
	let fileRef
	if(file instanceof QwoachFileRef){
		fileRef = file
	} else {
		fileRef = QwoachFileRef.fromFile(file)
	}
	if(!(fileRef instanceof QwoachFileRef)){
		throw Error("shareWith file type is unsupported: file = " + (typeof file))
	}

	let updateFunc
	switch (fileRef.qwoachFileType){
		case QwoachFileType.DRIVE_FILE:
		case QwoachFileType.LINK:
			updateFunc = dataManager.updateDriveFile
			break;
		case QwoachFileType.FORM:
			updateFunc = dataManager.updateFormItem
			break;
		case QwoachFileType.LEGAL_DOC:
			updateFunc = dataManager.updateContract
			break;
		case QwoachFileType.LEGAL_DOC_TEMPLATE:
			updateFunc = dataManager.updateDocSignTemplate
			break;
	}
	return updateFunc
}
